var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"index-wrap"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.statistics()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }